import revokeTokenHandler from '../../pattern_utilities/revokeTokenHandler';
import { push } from 'react-router-redux';
import generateText from '../../pattern_utilities/generateText';
import Hashids from 'hashids';

import { addToast, tryToGetMyPatterns, tryToGetTeamPatterns } from '../actions.export.js'

var pf_config = require('../../pf_config.json');
var hashids = new Hashids('k100p');
var Cookies = require('js-cookie');

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// SAVE A COPY OF THIS PATTERN
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

// export const pmSetCurrentPattern = data => ({
//   type: 'SET_CURRENT_PATTERN',
//   data
// })

const requestNewPattern = data => ({
  type: 'REQUEST_NEW_PATTERN',
  data
})

const receiveNewPatternSuccess = data => ({
  type: 'RECEIVE_NEW_PATTERN_SUCCESS',
  data
})

const receiveNewPatternFail = data => ({
  type: 'RECEIVE_NEW_PATTERN_FAIL',
  data
})

export const tryToSaveACopy = data => (dispatch, getState) => {
  dispatch(requestNewPattern(data));

  const { team, user } = getState();

  var new_pattern = Object.assign({}, data);

  if(new_pattern.format === 'AUTOCAD'){
    new_pattern.name = "Copy of " + new_pattern.name;
  } else {
    new_pattern.name = "Copy of " + new_pattern.name;
  }
  
  new_pattern.name = new_pattern.name.slice(0, 31);

  if(new_pattern.description && new_pattern.description !== ""){
    new_pattern.description = "Copy of: " + new_pattern.description;
    new_pattern.description.slice(0, 256);
  }


  new_pattern.text = generateText(new_pattern);

  delete new_pattern.history;


  // for users
  var url = '/api/patterns';
  new_pattern.scope = user.id;

  var team_pattern = false;
  // override if team
  if(team.current && team.cache[team.current]){
    new_pattern.scope = team.cache[team.current].id;
    url = '/api/patterns/team/' + new_pattern.scope;
    team_pattern = true;
    
  } else if(team.current && !team.cache[team.current]){
    return dispatch(receiveNewPatternFail({
      errors: 'You tried to create a new team pattern under a team that might not exist.',
      lastSubmit: new_pattern
    }))
  }
  
  return fetch(url, {
      method: 'post',
      body: JSON.stringify(new_pattern),
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + Cookies.get(process.env.REACT_APP_COOKIE_AUTH)
      }
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      json.text = generateText(json);
      json.saved = true;
      json.linkedToServer = true;
      dispatch(receiveNewPatternSuccess(json));

      dispatch(addToast({
        title: "Copy saved! 👍",
        detail: "Your copy can be found in your " + (team_pattern ? "Team" : "My") + " Patterns under the name \"" + new_pattern.name + "\".",
        func: 'cookieToastDismissed',
        autoDismiss: 3000,
        buttons: [
          {
            display: "Dismiss",
            dismissOnClick: true
          }
          // {
          //   display: "Go to Copy",
          //   destination: '/pat/' + hashids.encode(json.id)
          // }
        ]
      }));
      dispatch(tryToGetMyPatterns());

      if(team_pattern){
        dispatch(tryToGetTeamPatterns({
          id: team.current
        }));
      } else {
        dispatch(tryToGetMyPatterns());
      }
      
      
    })
    .catch(e => {
      revokeTokenHandler(e);
      dispatch(receiveNewPatternFail({errors:e, lastSubmit: data}));
    })
}



// WEBPACK FOOTER //
// ./src/actions/pattern/a.p.POST.save-a-copy.js